import { API } from "./api";

// Injects/updates the browser-tab favicon. Applies across all pages.
export function applyFavicon(version) {
  if (!version) return;
  const href = `${API}/branding/favicon?v=${encodeURIComponent(version)}`;
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

// Reads the active favicon from public settings and applies it (no auth needed).
export async function loadFavicon() {
  try {
    const res = await fetch(`${API}/settings`);
    if (!res.ok) return;
    const s = await res.json();
    if (s && s.favicon_version) applyFavicon(s.favicon_version);
  } catch (e) { /* keep default favicon */ }
}
